export type DeliveryProviderType = 'PLATFORM' | 'OWN_FLEET' | 'HYBRID';

export interface DeliveryProviderOption {
  value: DeliveryProviderType;
  title: string;
  description: string;
}

export const DELIVERY_PROVIDER_OPTIONS: DeliveryProviderOption[] = [
  {
    value: 'OWN_FLEET',
    title: 'Restoran Kuryesi',
    description: 'Siparişler yalnızca restoranın kendi kuryelerine atanır.',
  },
  {
    value: 'PLATFORM',
    title: 'Platform Kuryesi',
    description: 'Siparişler platform kuryelerine atanır.',
  },
  {
    value: 'HYBRID',
    title: 'Hibrit Kurye Sistemi',
    description:
      'Öncelikle restoranın kendi kuryelerine atama yapılır. Belirlenen süre içerisinde uygun restoran kuryesi bulunamazsa sipariş platform kuryelerine yönlendirilir.',
  },
];

export const DELIVERY_PROVIDER_LABELS: Record<DeliveryProviderType, string> = {
  PLATFORM: 'Platform Kuryesi',
  OWN_FLEET: 'Restoran Kuryesi',
  HYBRID: 'Hibrit Kurye Sistemi',
};
